import React, { useMemo } from "react";
import { VirtualLogList } from "./components/VirtualLogList";
import "./styles.css";

interface LogViewerPanelProps {
  title: string;
  logs: string;
  loading: boolean;
  error: string | null;
  downloadFileName: string;
  /**
   * `В4` (условие слияния `F-454`): **кнопки очистки здесь нет** и обработчика
   * для неё тоже. Прежняя кнопка стирала `app.log` бэкенда с любой страницы
   * трафика; очистка осталась одна — на `/admin/devlog`. Обманкой было бы
   * оставить обработчик «на будущее»: его снова подключили бы к трафику.
   */
  /**
   * `DEV-88` (`OPS-20` (в)): подпись под заголовком — что именно показывает эта
   * страница. Нужна там, где рядом живёт вторая страница логов и их легко
   * перепутать.
   */
  note?: string;
  children?: React.ReactNode;
}

export const LogViewerPanel: React.FC<LogViewerPanelProps> = ({
  title,
  logs,
  loading,
  error,
  downloadFileName,
  note,
  children,
}) => {
  const handleDownload = () => {
    const blob = new Blob([logs], { type: "text/plain" });
    const href = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = downloadFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  };

  const lines = useMemo(() => (logs ? logs.split("\n") : []), [logs]);

  return (
    <div className="log-viewer">
      <div className="log-header">
        <h3>{title}</h3>
        <div className="log-btnblock">
          <button onClick={handleDownload} className="download-btn">
            Скачать .log
          </button>
        </div>
      </div>

      {note && <p className="log-note">{note}</p>}

      {children}

      {loading && <p>Загрузка логов...</p>}
      {error && <p className="error">Ошибка: {error}</p>}

      {!loading && !error && <VirtualLogList lines={lines} />}
    </div>
  );
};
